export default __webpack_public_path__ + "public/assets/images/fccd6eab82bc4b03c5de3422d9e93b53.png";